import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["site-preview"];

  static targets = [
    "headingFont",
    "headingFontWeight",
    "headingFontCase",
    "bodyFont",
    "previewHeading",
    "previewBody",
    "hiddenFontPairingId",
    "sitePreviewContainer",
    "resetFont",
    "backButton",
    "previewCta",
    "headingStyle",
    "headingFontFamily",
    "bodyFontFamily",
  ];

  initialize() {
    this.setSiteFontsPreview();
  }

  connect() {
    this.loadInitialFonts();
  }

  disconnect() {
    this.bustAppearancePreviewCache(true);
  }

  setSiteFontsPreview() {
    const fontPairingId = this.hiddenFontPairingIdTarget.value;
    const fontHeadingName = $("#font_heading_id option:selected").data("family-name");
    const fontHeadingWeight = $("#font_heading_font_weight option:selected").val();
    const fontBodyName = $("#font_body_id option:selected").data("family-name");

    if (fontHeadingName || fontBodyName) {
      this.setCustomFontsPreview(fontHeadingName, fontBodyName, fontHeadingWeight);
    } else if (fontPairingId) {
      this.setFontPairingPreview(fontPairingId);
    } else {
      this.setDefaultPreview();
    }

    this.hideBackBtnLink();
  }

  setDefaultPreview() {
    this.hideResetSiteLink();
    this.unfocusFontsPreviewContainer();
    this.hideFontFamilyInfo();

    this.previewHeadingTarget.removeAttribute('style');
    this.previewBodyTarget.removeAttribute('style');
    this.sitePreviewContainerTarget.setAttribute('style', `text-align: center`);

    this.headingFontFamilyTarget.querySelector('span').innerHTML = ' Not Selected';
    this.bodyFontFamilyTarget.querySelector('span').innerHTML = ' Not Selected';

    this.previewHeadingTarget.innerText = "Select Site Fonts";
    this.previewBodyTarget.innerText = `Choose from our curated font pairings or pick your own.`;
  }

  setFontPairingPreview(fontPairingId) {
    this.showResetSiteLink();
    this.focusFontsPreviewContainer();

    const fontClassName = `font-pairing-${fontPairingId}`;
    $(`.selectable .${fontClassName}`).addClass("selected");

    this.previewHeadingTarget.removeAttribute('style');
    this.previewBodyTarget.removeAttribute('style');
  }

  setCustomFontsPreview(fontHeadingName, fontBodyName, fontHeadingWeight) {
    this.showResetSiteLink();
    this.focusFontsPreviewContainer();

    if(fontHeadingName) {
      this.previewHeadingTarget.setAttribute("style", `font-family: ${fontHeadingName} !important; font-weight: ${fontHeadingWeight || 'inherit'} !important;`);
      this.loadGoogleFonts([fontHeadingName]);
    } else {
      this.previewHeadingTarget.removeAttribute('style');
    }

    if(fontBodyName) {
      this.previewBodyTarget.setAttribute("style", `font-family: ${fontBodyName} !important`);
      this.loadGoogleFonts([fontBodyName]);
    } else {
      this.previewBodyTarget.removeAttribute('style');
    }
  }

  removeFontsPreviewStyles() {
    this.sitePreviewContainerTarget.classList = 'site-font';
  }

  resetDefaultFontPairing() {
    $(`.selectable .selected`).removeClass("selected");
    this.hiddenFontPairingIdTarget.value = "";
  }

  adjustFontTabStyles() {
    this.showBackBtnLink();
    $('#fonts_tab').css('padding-top', '0');
    this.backButtonTarget.setAttribute("style",`padding-top: 1em !important;`);
  }

  cacheCustomFontPreview(key, value) {
    const siteId = this.sitePreviewOutlet.siteId();
    this.resetDefaultFontPairing();

    this.fetcher({
      url: `/sites/${siteId}/cache_font_preview`,
      body: JSON.stringify({ key, value: value }),
      onSuccess: () => {
        this.sitePreviewOutlet.sync();
      },
    });

    this.showPreviewActionBtns();
  }

  bustAppearancePreviewCache(dirty) {
    if (dirty) {
      const siteId = this.sitePreviewOutlet.siteId();

      this.fetcher({
        url: `/sites/${siteId}/bust_appearance_preview_cache`,
        onSuccess: () => {
          this.sitePreviewOutlet.sync();
        }
      });
    }
  }

  discardChanges() {
    const persistentFontPairingId = $("#persistent_font_pairing_id").val();
    const persistentHeadingFontId = $("#persistent_heading_font_id").val();
    const persistentBodyFontId = $("#persistent_body_font_id").val();
    const fontClass = `font-pairing-${persistentFontPairingId}`;

    this.hiddenFontPairingIdTarget.value = persistentFontPairingId;
    $("#font_heading_id").val($("#persistent_heading_font_id").val());
    $("#font_heading_font_weight").val(
      $("#persistent_heading_font_weight_style").val()
    );
    $("#font_heading_case_style").val(
      $("#persistent_heading_font_case_style").val()
    );
    $("#font_body_id").val($("#persistent_body_font_id").val());

    this.bustAppearancePreviewCache(app.sidebar.dirty);
    this.hidePreviewActionBtns();
    if (persistentHeadingFontId) {
      this.headingStyleTarget.classList.remove('hidden');
    } else {
      this.headingStyleTarget.classList.add('hidden');
    }

    $(`.selectable .selected`).removeClass("selected");
    this.sitePreviewContainerTarget.classList= '';
    if (persistentFontPairingId) {
      $(`.selectable .${fontClass}`).addClass("selected");
      this.sitePreviewContainerTarget.classList.add("site-font", fontClass, "selected");
    } else if (persistentHeadingFontId || persistentBodyFontId) {
      this.sitePreviewContainerTarget.classList.add("site-font", "selected");
    } else {
      this.sitePreviewContainerTarget.classList.add("site-font");
    }
  }

  fetcher({ url, body, onSuccess }) {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body
    }).then((response) => {
      if (response.ok) {
        onSuccess()
      }
    });
  }

  loadInitialFonts() {
    const initialFonts = window.app.constants.google_fonts;
    this.loadGoogleFonts(initialFonts);
  }

  loadGoogleFonts(fonts) {
    window.WebFontConfig = window.WebFontConfig || {};
    window.WebFontConfig.google = window.WebFontConfig.google || {};
    window.WebFontConfig.google.families = window.WebFontConfig.google.families || [];
    window.WebFontConfig.google.families.push(...fonts);

    const wf = document.createElement("script");
    wf.src = "https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js";
    wf.async = true;
    document.head.appendChild(wf);
  }

  hideResetSiteLink() {
    this.resetFontTarget.classList.add("hide");
  }

  showResetSiteLink() {
    this.resetFontTarget.classList.remove("hide");
  }

  hideBackBtnLink() {
    this.backButtonTarget.classList.add("hidden");
  }

  showBackBtnLink() {
    this.backButtonTarget.classList.remove("hidden");
  }

  hidePreviewActionBtns() {
    this.previewCtaTarget.classList.add("hidden");
  }

  showPreviewActionBtns() {
    this.previewCtaTarget.classList.remove("hidden");
  }

  focusFontsPreviewContainer() {
    this.sitePreviewContainerTarget.classList.add("selected");
  }

  unfocusFontsPreviewContainer() {
    this.sitePreviewContainerTarget.classList.remove("selected");
  }

  hideFontFamilyInfo() {
    this.headingFontFamilyTarget.classList.add("hidden");
    this.bodyFontFamilyTarget.classList.add("hidden");
  }
}
